import { Shape } from "three";
import { useMemo } from "react";

export default function RoundedPlane({ width = 1, height = 1, radius = 0.2, color = "#FFF", opacity, ...props }) {
  const shape = useMemo(() => {
    const s = new Shape();
    s.moveTo(-0.2 + radius, -height / 2);
    s.lineTo(width  - radius, -height / 2);
    s.quadraticCurveTo(width , -height / 2, width , -height / 2 + radius);
    s.lineTo(width , height / 2 - radius);
    s.quadraticCurveTo(width , height / 2, width  - radius, height / 2);
    s.lineTo(-0.2  + radius, height / 2);
    s.quadraticCurveTo(-0.2 , height / 2, -0.2 , height / 2 - radius);
    s.lineTo(-0.2 , -height / 2 + radius);
    s.quadraticCurveTo(-0.2 , -height / 2, -0.2  + radius, -height / 2);
    return s;
  }, [width, height, radius]);

  return (
    <mesh {...props} position={[0,0,-0.01]}>
      <shapeGeometry args={[shape]}/>
      <meshBasicMaterial color={color} transparent opacity={opacity} />
    </mesh>
  );
}
